/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how column exchanging is animated.
 */
export var ColumnExchangingAnimationMode = /*@__PURE__*/ (function (ColumnExchangingAnimationMode) {
    /**
     * The correct animation mode is automatically selected.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["None"] = 1] = "None";
    /**
     * The cells slide to the left.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToLeft"] = 2] = "SlideToLeft";
    /**
     * The cells slide to the right.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToRight"] = 3] = "SlideToRight";
    /**
     * The cells slide to the top.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToTop"] = 4] = "SlideToTop";
    /**
     * The cells slide to the bottom.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToBottom"] = 5] = "SlideToBottom";
    /**
     * The cells crossfade.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["Crossfade"] = 6] = "Crossfade";
    /**
     * The cells slide to the left and crossfade.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToLeftAndCrossfade"] = 7] = "SlideToLeftAndCrossfade";
    /**
     * The cells slide to the right and crossfade.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToRightAndCrossfade"] = 8] = "SlideToRightAndCrossfade";
    /**
     * The cells slide to the top and crossfade.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToTopAndCrossfade"] = 9] = "SlideToTopAndCrossfade";
    /**
     * The cells slide to the bottom and crossfade.
     */
    ColumnExchangingAnimationMode[ColumnExchangingAnimationMode["SlideToBottomAndCrossfade"] = 10] = "SlideToBottomAndCrossfade";
    return ColumnExchangingAnimationMode;
})({});
/**
 * @hidden
 */
export var ColumnExchangingAnimationMode_$type = /*@__PURE__*/ markEnum('ColumnExchangingAnimationMode', 'Auto,0|None,1|SlideToLeft,2|SlideToRight,3|SlideToTop,4|SlideToBottom,5|Crossfade,6|SlideToLeftAndCrossfade,7|SlideToRightAndCrossfade,8|SlideToTopAndCrossfade,9|SlideToBottomAndCrossfade,10');
//# sourceMappingURL=ColumnExchangingAnimationMode.js.map
